import { memo, useState } from 'react';

import { NavDiversity, Plus } from '@air/next-icons';
import { DropdownMenuItem, DropdownMenuSeparator, DropdownMenuSub } from '@air/primitive-dropdown-menu';

import { WorkspaceHeaderInformationDropdownSwitchWorkspaceItemsWorkspaces } from '~/components/v2/components/workspace/workspace-header/WorkspaceHeaderInformationDropdownSwitchWorkspaceItemsWorkspaces';
import { intercomIDs } from '~/constants/intercomIDs';
import { useCreateWorkspace } from '~/hooks/useCreateWorkspace';

export const WorkspaceHeaderInformationDropdownSwitchWorkspaceItems = memo(() => {
  const [scrollElement, setScrollElement] = useState<HTMLDivElement | null>(null);
  const { createWorkspace } = useCreateWorkspace();

  return (
    <>
      <DropdownMenuSeparator />
      <DropdownMenuSub
        data-id="SWITCH_WORKSPACE"
        label="Switch workspace"
        prefix={<NavDiversity className="size-4" />}
        ref={setScrollElement}
        size="small"
        className="w-[calc(var(--sidebar-width)-24px)] min-w-[240px]"
        data-intercomid={intercomIDs.SWITCH_WORKSPACE}
      >
        {scrollElement && (
          <WorkspaceHeaderInformationDropdownSwitchWorkspaceItemsWorkspaces scrollElement={scrollElement} />
        )}
        <DropdownMenuSeparator />
        <DropdownMenuItem
          data-id="create-workspace"
          label="Join or create a workspace"
          onSelect={createWorkspace}
          prefix={<Plus className="size-4" />}
        />
      </DropdownMenuSub>
    </>
  );
});

WorkspaceHeaderInformationDropdownSwitchWorkspaceItems.displayName =
  'WorkspaceHeaderInformationDropdownSwitchWorkspaceItems';
